import {Backdrop, Container, Grid as _Grid} from '@material-ui/core'
import ButtonMedium from '../Buttons/ButtonMedium'
import Styled from '../Styled'
import H5 from '../Typography/H2'
import styles from './styles'

export const Root = Styled(Container, styles.root)
export const Grid = _Grid
export const Title = Styled(H5, styles.title)
export const TableTop = Styled(_Grid, styles.tableTop)
export const CreateButton = Styled(ButtonMedium, styles.createButton)
export const BusyBackdrop = Styled(Backdrop, styles.busyBackdrop)
